/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Sample_RejectedInputs */

const en_samples_edit_sample_rejected = /** @type {(inputs: Samples_Edit_Sample_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample rejected`)
};

const es_samples_edit_sample_rejected = /** @type {(inputs: Samples_Edit_Sample_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra rechazada`)
};

/**
* | output |
* | --- |
* | "Sample rejected" |
*
* @param {Samples_Edit_Sample_RejectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_sample_rejected = /** @type {((inputs?: Samples_Edit_Sample_RejectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Sample_RejectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_sample_rejected(inputs)
	return es_samples_edit_sample_rejected(inputs)
});